// Controller designed to be attached to the room card UI element in room
// selection part of the booking process.
// Note that this is really a "room offer" meaning it could actually be a single
// room or a set of rooms offered together.
stimulusApp.register(
  "room-card",
  class extends Stimulus.Controller {
    static targets = [
      "card",
      "infoModalContent",
      "input",
      "bookBtn",
      "notEnoughRooms",
    ]
    static classes = ["fadeIn", "hide", "partiallyHide", "selected"]
    static values = {
      roomUrl: String,
      roomQuantities: Object, // Room counts used for this room offer, by room id
      description: String, // Short description to be used when listing the room
    }

    connect() {
      this.currency = HB.state.currency()

      // Safeguard error checking, expected to never happen.
      const zeroQuantities = Object.values(this.roomQuantitiesValue).filter(
        (quantity) => quantity <= 0,
      )
      if (zeroQuantities.length > 0) {
        Bugsnag.notify("Hotwire booking flow error", {
          clientParams: {
            issue: "Room card has zero room quantities",
            room_quantities: this.roomQuantitiesValue,
          },
        })
      }

      // mark and scroll to the first selected room card
      // only happens on mobile
      this.toggleSelectedClass()
      if (this.selected()) {
        setTimeout(() => {
          this.element.scrollIntoView()
        }, 0)
      }

      // happens on mobile and desktop but has meaning only for desktop
      this.ToggleSelectedClassBinded = this.toggleSelectedClass.bind(this)
      $(document).on("hb:room-selected", this.ToggleSelectedClassBinded)
    }

    disconnect() {
      $(document).off("hb:room-selected", this.ToggleSelectedClassBinded)
    }

    toggleSelectedClass() {
      this.element.classList.toggle(this.selectedClasses, this.selected())
    }

    // Intended to be called by other Stimulus controllers, e.g. room details.
    chooseRatePlan(ofuuid) {
      this.inputTargets.find((input) => input.value === ofuuid)?.click()
    }

    match(filters) {
      return Object.entries(filters).every(([name, values]) => {
        const data = [].concat(
          JSON.parse(this.element.dataset.filterData)[name] ?? [],
        )
        return data.filter((val) => values.has(val)).length > 0
      })
    }

    selected() {
      return !!this.selectedInput()
    }

    rawSelectedPrices() {
      const dataset = this.selectedInput().dataset
      if (!dataset.guestPrice) {
        Bugsnag.notify("Guest price missing")
      }

      return {
        guest: dataset.guestPrice && parseInt(dataset.guestPrice, 10),
        agency: dataset.agencyPrice && parseInt(dataset.agencyPrice, 10),
      }
    }

    selectedPrice() {
      const { guest, agency } = this.rawSelectedPrices()
      const format = (price) => {
        return accounting.formatMoney(price, {
          precision: 0,
          symbol: this.currency.unit,
          format: this.currency.format,
        })
      }
      return {
        guest: guest && format(guest),
        agency: agency && format(agency),
      }
    }

    removeFadeIn() {
      this.element.classList.remove(...this.fadeInClasses)
    }

    partiallyHide() {
      this.element.classList.add(...this.partiallyHideClasses)
      this.element.classList.add(...this.hideClasses)
    }

    hide() {
      this.element.classList.add(...this.hideClasses)
      this.element.classList.remove(...this.partiallyHideClasses)
    }

    show() {
      this.element.classList.add(...this.fadeInClasses)
      this.element.classList.remove(...this.hideClasses)
      this.element.classList.remove(...this.partiallyHideClasses)
    }

    expand(e) {
      if (
        e.target.closest(".rooms-i--book") ||
        e.target.closest(".ignore-expanding")
      )
        return

      let frame = document.getElementById("popup_modal")

      if (this.hasInfoModalContentTarget && !!frame) {
        e.preventDefault()

        frame.replaceChildren(
          this.infoModalContentTarget.content.cloneNode(true),
        )
      } else {
        Turbo.visit(this.roomUrlValue, { frame: "popup_modal" })
      }
    }

    // Switch between book button and not enough rooms message, depending on
    // whether there's enough capacity for the needs of this room offer.
    updateAvailability(remainingCapacity) {
      if (this.selected()) return

      if (this.#capacityCoversRooms(remainingCapacity)) {
        this.#showBookButton()
      } else {
        this.#showNotEnoughRoomsMessage()
      }
    }

    isAvailable() {
      return (
        this.hasBookBtnTarget &&
        !this.bookBtnTarget.classList.contains("hidden")
      )
    }

    selectedInput() {
      return this.inputTargets.find((input) => input.checked)
    }

    #capacityCoversRooms(capacity) {
      let available = true
      Object.entries(this.roomQuantitiesValue).forEach(([key, value]) => {
        // null or not present means no limit, which means available
        available &&=
          !capacity.hasOwnProperty(key) ||
          (capacity.hasOwnProperty(key) &&
            (capacity[key] >= value || capacity[key] === null))
      })
      return available
    }

    #showBookButton() {
      if (this.hasBookBtnTarget) {
        this.bookBtnTarget.classList.remove("hidden")
      }
      if (this.hasNotEnoughRoomsTarget) {
        this.notEnoughRoomsTarget.classList.add("hidden")
      }
    }

    #showNotEnoughRoomsMessage() {
      if (this.hasBookBtnTarget) {
        this.bookBtnTarget.classList.add("hidden")
      }
      if (this.hasNotEnoughRoomsTarget) {
        this.notEnoughRoomsTarget.classList.remove("hidden")
      }
    }
  },
)
